import { sha1 } from '@angular/compiler/src/i18n/digest';
import { Observable } from './classes/observable';
import { environment } from '../environments/environment';
import { UsuarioService } from './service/usuario.service';
import { CryptoJSAesJson, ServiceService } from './service/service.service';
import { Pago } from './classes/Pago';
import { HomePage } from './pages/modulos/home/home.page';

import { CambiarCuentaPage } from './components/cambiar-cuenta/cambiar-cuenta.page';
import {
  IngresaPinPage
} from './pages/seguridad/ingresa-pin/ingresa-pin.page';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { Platform } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { menuController } from "@ionic/core";
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Deeplinks } from '@ionic-native/deeplinks'
import { AmigosPage } from './pages/modulos/amigos/amigos.page';
import { IngresoDineroPage } from './pages/modulos/ingreso-dinero/ingreso-dinero.page';
import { PermisoService } from './service/permiso.service';
import { FcmService } from './service/fcm.service';
import { LoginService } from './service/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { NavigationStart } from '@angular/router';
import { Location } from '@angular/common';
import * as CryptoJS from 'crypto-js';
import { BiometricAuthService } from './service/biometric-auth.service';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  public usuario;
  public empresa;
  public iniciales;
  public iniciales_empresa;
  public modalDataResponse: any;
  public static cargando = false;
  public static splash = true;
  public static menu = Array();
  public static DIAS = 1;
  public static login = false;
  public static token;
  public static validado = true;
  public static module:boolean = false;
  public static logueando=false;
  public nombreInicial;
  public static platform:Platform;
  public static inError = false;
  public static validatingResume = false;
  public static lastResumeValidationAt = 0;
  constructor(public log_in: LoginService,public permisoService: PermisoService, public Router: Router, private platform: Platform, private statusBar: StatusBar, private splashScreen: SplashScreen, private pago: Pago, public service: ServiceService, public modalCtrl: ModalController, public usuarioService: UsuarioService, public navCtrl: NavController, public fcm: FcmService,public route:ActivatedRoute, public location:Location, private biometricService: BiometricAuthService) {
    this.splashScreen.show();

    this.Router.errorHandler = (error: any) => {
      this.Router.navigate(['home']); // or redirect to default route
    }

    Observable.suscribe("tapNoti", (nav) => {
      this.Router.navigate(['/' + nav]);
    })
    AppComponent.platform = this.platform;
    if(this.platform.is("desktop")){
      this.splashScreen.hide();
      AppComponent.splash=false;
    }
    environment.mobile = platform.is("cordova");
    this.statusBar.overlaysWebView(false);
    this.statusBar.backgroundColorByHexString('#000000');
    let validado = false;
    Observable.suscribe("noMobilePermit", function (router: Router) {
      /* ESTO ESTA PARA QUE NO SE PUEDA INSTANCIAR LA APP MODO APP EN EL BROWSER*/
      // console.error(platform.is("ipad")); 
      // console.error(platform.is("android")); 
      // console.error(platform.is("iphone"));
      // console.error(platform.is("ios"));
      // console.error(platform.is("desktop"));
      // console.error(platform.is("pwa"));
      // console.error(platform.is("mobileweb"));
      
      

      if( environment.onlyWeb && 
          !platform.is("desktop") && 
          platform.is("mobileweb")
      ){
        Observable.unsuscribe("noMobilePermit");
        return router.navigate(['/accesodenegado']);
      }
    })
    Observable.notify("noMobilePermit",this.Router);
    Observable.suscribe("logueando",function(data){
      AppComponent.logueando=data;
    })
    Observable.suscribe("borrar",()=>{
      localStorage.removeItem("nombreEmpresa");
      localStorage.removeItem("mail");
      localStorage.removeItem("proceso_alta");
      localStorage.removeItem("iniciales");
      localStorage.removeItem("validaciones");
      localStorage.removeItem("notification");
      localStorage.removeItem("onboardingLastPage");
      localStorage.removeItem("varsOnboarding");
      localStorage.removeItem("cuentas");
      localStorage.removeItem("modalAbiero");
      localStorage.removeItem("inicialesEmpresa");
      localStorage.removeItem("token");
      localStorage.removeItem("nombre");
    })

    Observable.suscribe("safeUrl",()=>{
      this.location.replaceState("/"+CryptoJS.SHA256(this.Router.getCurrentNavigation().id.toString()).toString(CryptoJS.enc.Hex));
    });
    if(!validado){
      Observable.notify("logueando",true);
    }

    
    this.Router.events.subscribe(async (event) => {
      
      if(!validado){
        if(window.location.href.split("?")[1])
          var formodule=window.location.href.split("?")[1].match("formodule");
        if(formodule){
          var token_ext=window.location.href.split("?")[1].match("formodule").input.split("=")[1];
        }
        if(formodule!=null){
          Observable.notify("logueando",true);
          validado=true;
          Observable.notify("borrar",false);
          this.log_in.loginshouldmodule(token_ext).then(data=>{
              this.Router.navigate(['/']);
          });
        }
        else{
          Observable.notify("logueando",false);
          validado=true;
        }
      }
      if (event instanceof NavigationStart) {
        if (event.url.toString() != "/home" && event.url.toString() != "") {
          if (localStorage.getItem("token") != undefined && localStorage.getItem("token") != "undefined" && localStorage.getItem("token") != "false") {
            if (!["/home", "", "/ingreso", "/welcome", "/personapfpj"].includes(event.url.toString()))
              await this.permisoService.puede(event.url.substring(1, event.url.length)).then(data => {
                Observable.notify("SlashHide", false);
                return;
              }).catch(data => {
                this.Router.navigate(['/accesodenegado']);
              });
          }
        }
      }
      if (event instanceof NavigationEnd) {
        if ((event.url.toString()) !== '' && (event.url.toString() !== '/home') && (event.url.toString() !== '/welcome')) {
          Observable.notify("SlashHide", false);
        }
        Observable.notify("safeUrl", null);
      }
    });
    
  }

  getIniciales(){
    if(this.nombreInicial!=null)
      return this.nombreInicial;
    if(null != localStorage.getItem("cuentas"))
      this.nombreInicial=JSON.parse(localStorage.getItem("cuentas")).filter(dato=>dato.token==localStorage.getItem("token"))[0].iniciales;
    else
      this.nombreInicial = "N/A";
    this.iniciales=this.nombreInicial;
    return this.nombreInicial;
  }


  mostrar_menu() {
    if(this.is_modulecd()!=null){
      AppComponent.module = this.is_modulecd();
      return AppComponent.module==false;
    }
    return AppComponent.login;
  }
  
  is_modulecd():boolean{    
    if(this.route.snapshot.queryParamMap.get('formodule')!=null)
      return this.route.snapshot.queryParamMap.get('formodule')!==null;
    return null;
  }
  
  es_valido() {
    const cuentas = JSON.parse(localStorage.getItem("cuentas"));
    if (cuentas && cuentas.length > 0)
      return true;
    return AppComponent.validado;
  }
  es_usuario_validado() {
    return AppComponent.validado;
  }
  async ngOnInit() {
    localStorage.setItem("modalAbiero", "0");
    let nombre = localStorage.getItem("nombre");
    if (nombre && this.iniciales) {
      this.usuario = nombre;
      return false;
    }

    if (localStorage.getItem("token") != null)
      this.usuarioService.obtener_mis_datos().then((data: any) => {
        this.usuario = data.nombre_completo;
        this.iniciales = data.nombre
          .charAt(0)
          .toUpperCase()
          + data.apellido
            .charAt(0)
            .toUpperCase();
        localStorage.setItem("nombre", this.usuario);
        localStorage.setItem("iniciales", this.iniciales);
        AppComponent.login = true;
      })
    this.platform.pause.subscribe(() => {
      return this.onPause();
    });
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      document.addEventListener("stopped", this.onStop, false);
      document.addEventListener("pause", this.onPause, false);
      document.addEventListener("resume", this.onDeviceresume, false);
      document.addEventListener("freeze", this.onPause, false);

       /*Esto es un test para mas adelante no borrar*/
      // Deeplinks.routeWithNavController(this.navCtrl, {
      //   '/': HomePage,
      //   '/amigos': AmigosPage,
      //   '/ingresodinero': IngresoDineroPage
      // }).subscribe((match) => {
        
      // }, (nomatch) => {
      //   console.warn('Unmatched Route', nomatch);
      // });

      this.pago.registrar_observer();

      // Deep link: efectivodigital://mfa/aprobar?id=...&sesion=...
      // cordova-plugin-customurlscheme / ionic-plugin-deeplinks disparan window.handleOpenURL
      (window as any).handleOpenURL = (url: string) => {
        this.navegarDeepLink(url);
      };
    });

    Observable.suscribe("SlashHide", (data) => {
      setTimeout(() => {
        this.splashScreen.hide();
        AppComponent.splash = false;
      }, 10);
    })
    await this.getIniciales();
  }
  // ── Footer nav ──────────────────────────────────────────
  public showMoreMenu = false;

  navFooter(path: string) {
    this.navCtrl.navigateForward(path);
  }

  IrMore(path: string) {
    this.showMoreMenu = false;
    this.navCtrl.navigateForward(path);
  }

  toggleMoreMenu() {
    this.showMoreMenu = !this.showMoreMenu;
  }

  closeMoreMenu() {
    this.showMoreMenu = false;
  }

  isNative(): boolean {
    return this.platform.is('cordova');
  }

  isActive(path: string): boolean {
    const url = this.Router.url.split('?')[0];
    return url === '/' + path || url.startsWith('/' + path + '/') || url.startsWith('/' + path + ';');
  }

  cambiarCuenta() {
    this.showMoreMenu = false;
    this.cambiar();
  }
  // ────────────────────────────────────────────────────────

  Ir(path) {
    this.navCtrl.navigateForward(path);
    menuController.close();
  }
  obtener_menu(i) {
    return AppComponent.menu[i];
  }
  obtener_grupo() {
    let grupo = new Array();
    for (let i = 1; i <= Object.keys(AppComponent.menu).length; i++) {
      grupo.push(i);
    }
    return grupo;
  }
  get_iniciales() {
    if (!this.iniciales)
      this.iniciales = localStorage.getItem("iniciales");

    return this.iniciales;
  }
  get_iniciales_empresa() {
    if (!this.iniciales_empresa || this.iniciales_empresa != localStorage.getItem("inicialesEmpresa"))
      this.iniciales_empresa = localStorage.getItem("inicialesEmpresa");

    return this.iniciales_empresa;
  }
  get_empresa() {
    if (!this.empresa || this.empresa != localStorage.getItem("nombreEmpresa"))
      this.empresa = localStorage.getItem("nombreEmpresa");
    return this.empresa;
  }
  get_menu() {
    return AppComponent.menu;
  }
  addClass() {
    if (this.platform.is("ios"))
      return "bajarIos";
    return "";
  }
  getCargando() {
    return AppComponent.cargando;
  }
  getSplash() {
    if (document.getElementById("splash") == null) {
      return false;
    }
    if (AppComponent.splash == false) {
      document.getElementById("splash").setAttribute("class", "noVisible");
    }
    else {
      document.getElementById("splash").setAttribute("class", "Visible");
    }
    return true;
  }

    validar(item){
      if(["Amigos","Ingreso de dinero","Transferir dinero","Retiro de dinero"].includes(item.nombre) && this.platform.is("desktop") && (!this.platform.is("android") && !this.platform.is("ios"))){
          return false;
      }
      else{
        if(["lotedetransferencia","Lote de transferencias"].includes(item.nombre)&& !(this.platform.is("desktop") && (!this.platform.is("android") && !this.platform.is("ios")))){
          return false;
        }
      }
      return true;
    }

  onDeviceresume = () => {
    AppComponent.splash = false;
    const splashEl = document.getElementById("splash");
    if (splashEl) splashEl.setAttribute("class", "noVisible");
    Observable.notify("SlashHide", false);

    // Guardia 1: ya hay una validación en curso (ej: diálogo biométrico dispara pause/resume)
    if (AppComponent.validatingResume) return;

    // Guardia 2: cooldown de 3 s post-validación (evita resumes espurios al cerrar el diálogo)
    if (Date.now() - AppComponent.lastResumeValidationAt < 3000) return;

    // Guardia 3: solo validar si el pause fue real (pantalla bloqueada o app en background)
    if (localStorage.getItem("inBackground") !== "1") return;

    if (localStorage.getItem("token") != "false" && localStorage.getItem("token") != null && localStorage.getItem("token") != "" && localStorage.getItem("onboarding") == null && localStorage.getItem("onboarding") != "1") {
      localStorage.setItem("modalValidado", "0");
      this.validarResumeConBiometria();
    }
  }

  validarResumeConBiometria = async () => {
    AppComponent.validatingResume = true;
    // Intentar biometría primero
    const canUseBio = await this.biometricService.canUseBiometricForMfa();
    if (canUseBio) {
      try {
        const result = await this.biometricService.validateBiometric();
        if (result) {
          localStorage.setItem("inBackground", "0");
          AppComponent.validatingResume = false;
          AppComponent.lastResumeValidationAt = Date.now();
          return;
        }
      } catch (e) {
        console.log('[Resume] Biometría cancelada, mostrando PIN');
      }
    }
    // Fallback: mostrar modal de PIN
    if (localStorage.getItem("pin") == undefined || AppComponent.modal_abierto == 1) {
      // No hay PIN configurado o ya hay un modal abierto — liberar guardia
      AppComponent.validatingResume = false;
      AppComponent.lastResumeValidationAt = Date.now();
      return;
    }
    this.mostrarModal("validar");
  }

  onPause = () => {
    if(localStorage.getItem("token")!=="undefined" && localStorage.getItem("token")!=="false"){
        AppComponent.splash = true;
        localStorage.setItem("inBackground", "1");
        const splashEl = document.getElementById("splash");
        if (splashEl) splashEl.setAttribute("class", "visible");
    }

  }

  onStop = () => {
    

  }

  validarClave(clave1, clave2): Boolean {
    if (clave1 === clave2)
      return true;
    return false;
  }

  async mostrarModal(tipo) {
    Observable.notify("SlashHide", false);
    if (AppComponent.modal_abierto == 1 || localStorage.getItem("pin") == undefined) {
      Observable.notify("SlashHide", false);
      return false;
    }
    const modal2 = await this.modalCtrl.create({
      component: IngresaPinPage,
      componentProps: { tipo: tipo }
    });

    modal2.onDidDismiss().then(async (modalDataResponse) => {
      let clave1;
      Observable.notify("SlashHide", false);
      clave1 = modalDataResponse.data;
      localStorage.setItem("inBackground", "0");
      AppComponent.modal_abierto = 0;
      AppComponent.validatingResume = false;
      AppComponent.lastResumeValidationAt = Date.now();
      return true;
    });
    AppComponent.modal_abierto = 1;
    await modal2.present().then(() => {
      Observable.notify("SlashHide", false);
    });


  }

  private navegarDeepLink(url: string) {
    try {
      const urlObj = new URL(url);
      if (urlObj.hostname === 'mfa' && urlObj.pathname === '/aprobar') {
        const id = urlObj.searchParams.get('id');
        const sesion = urlObj.searchParams.get('sesion');
        if (id && sesion) {
          this.navCtrl.navigateForward(['aprobacion-mfa'], {
            queryParams: { id, sesion }
          });
        }
      }
    } catch (e) {
      console.warn('[DeepLink] URL no reconocida:', url);
    }
  }

  public static modal_abierto = 0;
  IrAtras() {
    this.navCtrl.back();
  }

  MenuAyuda() {
    this.navCtrl.navigateForward("ayuda");
    menuController.close()
  }

  async cambiar() {
    const modal3 = await this.modalCtrl.create({
      component: CambiarCuentaPage,
    });
    modal3.onDidDismiss().then(async (modalDataResponse) => {
      await menuController.close()  
      localStorage.removeItem("nombre");
      localStorage.removeItem("iniciales");
      this.iniciales = false;
      this.usuario = false;
      await localStorage.setItem("CambioCuenta", "1");
      this.Router.navigateByUrl("");
    });
    await modal3.present();
  }
}

